import React from 'react';
// import ReactDOM from 'react-dom'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Mid2ColRunde from '../containers/Mid2ColRunde';


import { acAxiosRequest } from '../actions/acAxiosRequest'
// import { acToggleMobile } from '../actions/acToggleMobile'
// import { acConSizeChange } from '../actions/acConSizeChange'

// import classNames from 'classnames';


class Mid2ColSt extends React.Component {

    constructor() {
        super();
        this.state = {
            coun: 0
        };

    }
    componentDidMount() {
        if (!this.props.activeLot) {
            var axios = {
                ruta: this.props.appProps.ruta,
                request: 'get_rounds',
                reducer: 'RUNDE',
                value: 'lottery_name=' + this.props.loterii[0].name_lot.replace(/ /g, '_') + '&type=0',
                newParam: this.props.sessionParam
            }
            this.props.acAxiosRequest(axios);
            if (this.props.serverTime) {
                this.checkRoundExpired(this.props.serverTime.server_time);
            }
        }
    }
    componentDidUpdate(prevProps, prevState) {

        // if ((this.refs.colMid) && (this.refs.colMid.offsetHeight > 100)) {

        // }


        // var dimensions = ReactDOM.findDOMNode(this).getBoundingClientRect();
        // this.props.acConSizeChange({ colMid: dimensions.height })


    }
    componentWillReceiveProps(nextProps) {

        if ((nextProps.serverTime) && (this.props.serverTime)) {
            if (nextProps.serverTime.server_time !== this.props.serverTime.server_time) {
                this.checkRoundExpired(nextProps.serverTime.server_time)
            }
        }
    }
    checkRoundExpired(val) {
        var serverTime = val.split(':');
        var min = serverTime[0];
        var sec = serverTime[1];

        if (min.slice(-1) < 5) {
            var min5 = 5 - min.slice(-1);
        }
        if (min.slice(-1) >= 5) {
            min5 = 10 - min.slice(-1);
        }

        var timer = (min5 * 60 * 1000) - sec * 1000;
        // console.log(this.millisToMinutesAndSeconds(timer));
        // console.log('setInterval - ', timer);
        var interval = setInterval(function () {
            var axios = {
                ruta: this.props.appProps.ruta,
                request: 'get_rounds',
                reducer: 'RUNDE',
                value: 'lottery_name=' + this.props.activeLot.name_lot.replace(/ /g, "_") + '&type=0',
                newParam: this.props.sessionParam
            }
            this.props.acAxiosRequest(axios);
            var axiosServerTime = {
                ruta: this.props.appProps.ruta,
                request: 'server_time',
                reducer: 'SERVER_TIME',
                newParam: this.props.sessionParam
            }
            this.props.acAxiosRequest(axiosServerTime);
            clearInterval(interval);
            // console.log('clearInterval');
        }.bind(this), timer); // timer

    }
    millisToMinutesAndSeconds(millis) {
        var minutes = Math.floor(millis / 60000);
        var seconds = ((millis % 60000) / 1000).toFixed(0);
        return minutes + ":" + (seconds < 10 ? '0' : '') + seconds;
    }
    odds() {
        var odds = []
        for (var i = 0; i < this.props.activeLot.odds.length; i++) {
            odds.push(<td key={i}>{this.props.activeLot.odds[i]}</td>)
        }
        return odds;
    }
    activeConBile(val) {
        // console.log(val);
    }
    toggleMobile() {
        // if (this.props.toggleMobile.runde === true) {
        //     return 'mob'
        // } else {
        //     return ''
        // }
    }
    closeMob() {
        // this.props.acToggleMobile({ runde: !this.props.toggleMobile.runde, loterie: false, overlay: false })
    }
    resize() {
        // return (
        //     {
        //         height: this.props.conSizeChange,
        //         overflowY: 'auto',
        //         overflowX: 'hidden'
        //     }
        // )
    }
    nrOdds() {
        var arr = []
        for (let i = 0; i < this.props.activeLot.nr_odds; i++) {
            arr.push(<th key={i}>{i + 1}</th>)
        }
        return arr
    }
    render() {
        if ((this.props.activeLot !== null) && (this.props.runde !== null)) {
            // console.log('ColoanaMid', this.props);


            return (
                <div className={"col-mid col2 " + this.toggleMobile()} ref="colMid" style={this.resize()}>
                    <div className="col-mid-mob-header">
                        <span>{this.props.multiLang.runda.txt}</span>
                        <span onClick={this.closeMob.bind(this)}>X</span>
                    </div>
                    <table>
                        <thead >
                            <tr className="module-header">
                                <th colSpan="2">
                                    <img src={"img/steaguri/" + this.props.appProps.steaguri + "/svg/" + this.props.activeLot.country_flags.toLowerCase().replace(/ /g, "_") + ".svg"} alt="" />
                                    <span>{this.props.activeLot.name_lot} {this.props.activeLot.game_type}</span>
                                </th>
                                {this.nrOdds()}
                            </tr>
                            <tr><th colSpan="10"></th></tr>
                        </thead>
                        {
                            this.props.runde.map((val, i) => {
                                // console.log(val);
                                return (
                                    <Mid2ColRunde
                                        key={val.round_unique}
                                        index={i}
                                        rundaVal={val}
                                    />
                                )
                            })
                        }

                    </table>
                </div>
            )
        }
        else {
            return <div></div>
        }
    }
}
function mapStateToProps(state) {
    return {
        appProps: state.appProps,
        activeLot: state.activeLot,
        defaultVal: state.defaultVal,
        runde: state.runde,
        serverTime: state.serverTime,
        toggleMobile: state.toggleMobile,
        multiLang: state.multiLang,
        sessionParam: state.sessionParam
    }
}
function matchDispatchToProps(dispatch) {
    return bindActionCreators({
        acAxiosRequest: acAxiosRequest,
        // acToggleMobile: acToggleMobile,
        // acConSizeChange: acConSizeChange
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(Mid2ColSt);
